<template>
  <div class="zpa-row search-box " :class="oneRow" slot="search" style="padding: 0;">
    <zpa-form
        ref="Form"
        :label-width="64"
        style="flex: auto; background: transparent;"
        inline
        :labelAlign="labelAlign"
    >
      <zpa-form-group middle inline>
        <slot></slot>
      </zpa-form-group>
    </zpa-form>

    <div class="zpa-row middle" style="height: 60px; padding:28px 8px 0; margin-top: 8px;">
      <Tooltip content="查询" transfer theme="light">
        <Button type="primary" @click="onClickSearch">
          <Icon type="md-search" :size="20" />
        </Button>
      </Tooltip>

      <Tooltip content="重置" transfer theme="light">
        <Button @click="onClickReset">
          <Icon type="md-refresh" :size="20" />
        </Button>
      </Tooltip>
      <slot name="export" v-if="isNeedExport"></slot>
      <Tooltip content="折叠" transfer theme="light" v-if="isNeedFold && !isFold">
        <Button icon="ios-arrow-up" @click="fold">
        </Button>
      </Tooltip>
      <Tooltip content="展开" transfer theme="light" v-if="isNeedFold && isFold">
        <Button icon="ios-arrow-down"  @click="fold">
        </Button>
      </Tooltip>
      <!--      <zpa-form ref="Form">
              <zpa-form-group class="extra" middle inline>
                <slot name="extra"></slot>
              </zpa-form-group>
            </zpa-form>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',

  data() {
    return {
      isFold: true,
    }
  },

  props: {
    primaryText: {
      type: String,
      default: '搜索',
    },
    labelAlign: {
      type: String,
      default: 'top',
    },
    inBox: Boolean,
    isNeedExport: {
      type: Boolean,
      default: true,
    },
    isNeedFold: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    form() {
      return this.$refs.Form
    },
    oneRow() {
      return {
        'one-row': this.isFold && this.isNeedFold,
      }
    },
  },

  methods: {
    fold() {
      this.isFold = !this.isFold
      this.$root.$emit('resize')
    },

    onClickSearch() {
      this.$emit('search')
    },

    onClickReset() {
      this.$refs.Form.reset()
      this.$emit('reset')
    },

    onClickExport(name) {
      this.$emit('export', name)
    },
  },

  watch: {
    isFold() {
      this.$root.$emit('resize')
    },
    labelAlign() {
      console.log(this.labelAlign)
    },
  },
}
</script>

<style scoped lang="less">
.one-row{
  height: 76px;
  overflow: hidden;
}
.search-box {
  button {
    margin-left: 8px;
  }
}
.extra-button{
  margin-left: 8px;
}

.extra {
  /deep/ .zpa-row {
    flex-wrap: nowrap;
    align-items: center;
  }
}
</style>
